module.exports = __webpack_public_path__ + "media/images/about-head-19de30de955bae68314da42a2c752824.png";